import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ComOptSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getCommOptSearch(data);
    }
}
export default ComOptSearchUseCase;
